// termsAndSubSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TermsState {
  isTermsAccepted: boolean;
  isTermsAndConditionAccepted: boolean;
}

const initialState: TermsState = {
  isTermsAccepted: false,
  isTermsAndConditionAccepted: false,
};

const termsAndSubSlice = createSlice({
  name: 'terms',
  initialState,
  reducers: {
    setIsTermsAccepted: (state, action: PayloadAction<boolean>) => {
      state.isTermsAccepted = action.payload;
    },
    setIsTermsAndConditionAccepted: (state, action: PayloadAction<boolean>) => {
      state.isTermsAndConditionAccepted = action.payload;
    },
  },
});

export const { setIsTermsAccepted, setIsTermsAndConditionAccepted } =
  termsAndSubSlice.actions;

export default termsAndSubSlice.reducer;
